var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.listRoute)?_c('div',[(!_vm.adverseEventId)?[_c('adverse-event-data-table',{attrs:{"list-route":_vm.listRoute}})]:_vm._e(),_vm._v(" "),(_vm.adverseEventId)?[_c('adverse-event-form-component')]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }